const categoryGA = 'headerMenu';

export const NAVIGATION_TRACKING_LOGO_BUTTON = {
  categoryGA,
  actionGA: 'header_logo',
  labelGA: null, // to override any value coming from previous tracking
};

export const NAVIGATION_TRACKING_CONTACT_BUTTON = {
  categoryGA,
  actionGA: 'header_contact',
  labelGA: 'clickToCall',
};

export const NAVIGATION_TRACKING_SEARCH_BUTTON = {
  categoryGA: 'headerMenu',
  actionGA: 'header_search',
};

export const getNavigationCallCenterButtonTrackingData = label => ({
  categoryGA,
  actionGA: 'header_contact',
  labelGA: label,
});

export const getNavigationLanguagesButtonTrackingData = label => ({
  categoryGA,
  actionGA: 'header_language',
  labelGA: label,
});

export const getNavigationItemLinkTrackingData = label => ({
  categoryGA,
  actionGA: `header_${label}`,
  labelGA: label,
});

export const getNavigationSubItemLinkTrackingData = ({ label, parentLabel }) => ({
  categoryGA,
  actionGA: `header_${parentLabel}`,
  labelGA: label,
});
